import { useRef } from 'react'
import MarketingHeader from '../components/MarketingHeader'
import AppFooter from '../components/AppFooter'
import Hero from '../components/landing/Hero'
import TrustMarquee from '../components/landing/TrustMarquee'
import FeatureBento from '../components/landing/FeatureBento'
import HowItWorks from '../components/landing/HowItWorks'
import Showcase from '../components/landing/Showcase'
import StatsBand from '../components/landing/StatsBand'
import FinalCta from '../components/landing/FinalCta'
import '../components/landing/landing.css'

// Logged-out landing page. Sections live in components/landing/; this page
// only composes them and wires the hero's "see examples" scroll target.
const Home = () => {
  const showcaseRef = useRef<HTMLElement>(null)

  return (
    <div className="bg-story-gradient min-h-[100dvh] overflow-x-clip text-celebration-ink dark:text-[#f4f0ff]">
      <MarketingHeader />
      <Hero
        onSeeExamples={() =>
          showcaseRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      />
      <TrustMarquee />
      <FeatureBento />
      <HowItWorks />
      <Showcase ref={showcaseRef} />
      <StatsBand />
      <FinalCta />
      {/* Mockup footer: dark ink band with a violet blob glowing bottom-right. */}
      <div className="relative overflow-hidden bg-celebration-ink dark:bg-[#0e081f]">
        <div
          aria-hidden="true"
          className="blob blob-violet"
          style={{ width: 420, height: 420, bottom: -180, right: -140, opacity: 0.18 }}
        />
        <div className="relative">
          <AppFooter maxWidth="max-w-6xl" variant="onDark" bordered={false} />
        </div>
      </div>
    </div>
  )
}

export default Home
